import { INGEST_RUN_DEFAULT_DAYS } from './adsIngestRunsConstants';

const isNil = (value) => value === null || value === undefined;

export const formatRows = (record) => {
  const written = isNil(record.rows_written) ? '–' : record.rows_written;
  const received = isNil(record.rows_received) ? '–' : record.rows_received;
  return `${received} / ${written}`;
};

export const isRowsShort = (record) =>
  !isNil(record.rows_written) && !isNil(record.rows_received) && record.rows_written < record.rows_received;

export const formatDuration = (ms) => (isNil(ms) ? '' : `${(ms / 1000).toFixed(1)} s`);

// 'YYYY-MM-DD' parsed as a local date, so the day does not shift with the timezone
const formatDay = (value) => {
  if (!value) return '';
  const [year, month, day] = String(value).split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
};

export const formatWindow = (from, to) => {
  if (!from && !to) return '';
  return `${formatDay(from)} – ${formatDay(to)}`;
};

export const formatPage = (record) => (record.pages > 1 ? `${record.page}/${record.pages}` : '');

const toLocalIsoDate = (date) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

export const getDefaultReceivedFrom = () => {
  const today = new Date();
  return toLocalIsoDate(new Date(today.getFullYear(), today.getMonth(), today.getDate() - INGEST_RUN_DEFAULT_DAYS));
};
